import React, { useState, useEffect } from 'react'
import InfoIcon from "website/home/info-icon.svg"
import EstimateInput from "./EstimateInput"
import AssumptionsContents from "./AssumptionsContents"
import CalculatorAssumptions from '../../Calculators/components/calculators-layout/CalculatorAssumptions';
import { postRequest } from 'servos/apiRequests'
import {
  numberClearCommas,
} from 'servos/formValidations'

const postRefinance = (data, onSuccess, onFailure) => {
  let url = '/calculators/refinance.json'
  postRequest({ url, data, onSuccess, onFailure })
}

const EstimateRefinancingCalc = ({ setResult }) => {
  const [loanTarget, setLoanTarget] = useState('own_home');
  const [currentLoanAmount, setLoanAmount] = useState();
  const [interestRate, setInterestRate] = useState();
  const [otherMonthlyFees, setOtherMonthlyFees] = useState();
  const [remainingLoanTerm, setRemainingLoanTerm] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const onCalculationSuccess = (response) => {
    setResult(response.data)
  }

  const onCalculationFailure = () => {
    setResult(null)
    let swalTitle = I18n.t('calculators.generic_error.title')
    let swalText = I18n.t('calculators.generic_error.description')

    swal({
       title: swalTitle,
       text: swalText,
       type: 'warning',
       showCancelButton: false,
       confirmButtonText: 'Close',
       allowOutsideClick: false,
       confirmButtonColor: "#10c98f",
    })
  }

  const getCalculation = () => {
    const currentInterestRate = parseFloat(interestRate) * 0.01
    const monthlyFees = otherMonthlyFees ? otherMonthlyFees : 0;
    let data = {
      refinance: {
        type: loanTarget,
        currentLoanAmount,
        currentInterestRate,
        otherMonthlyFees: monthlyFees,
        remainingLoanTerm
      }
    }

    postRefinance(data, onCalculationSuccess, onCalculationFailure)
  }

  useEffect(() => {
    const hasAllFieldFilled = currentLoanAmount && interestRate && remainingLoanTerm
    if (hasAllFieldFilled) {
      setButtonDisabled(false)
    } else {
      setButtonDisabled(true)
    }
  }, [currentLoanAmount, interestRate, otherMonthlyFees, remainingLoanTerm])

  return (
    <div className="estimate-refinance-calc-form">
      <div className="btn-group btn-group-radio-tabs btn-group-toggle btn-group-lg d-flex w-100" data-toggle="buttons">
        <label 
          className="btn onboarding-form active"
          onClick={() => setLoanTarget('own_home')}
        >
          <input id="option-refinance" autocomplete="off" checked="" name="options" type="radio"/>
          To Live in
        </label>
        <label 
          className="btn onboarding-form black"
          onClick={() => setLoanTarget('investment')}
        >
          <input id="option-refinance" autocomplete="off" name="options" type="radio"/>
          To Invest in
        </label>
      </div>

      <EstimateInput
        label="My current loan amount"
        placeholder="Enter amount"
        id={'enter-amount'}
        icon="$"
        value={currentLoanAmount}
        tooltipText={'Enter your outstanding loan amount.'}
        onChange={(e) => setLoanAmount(numberClearCommas(e.target.value))}
      />
      <EstimateInput
        isInterestRate={true}
        label="My current interest rate"
        placeholder="Enter interest rate"
        id={'interest-amount'}
        icon="%"
        value={interestRate}
        tooltipText={'Enter your current interest rate. If you’re paying multiple rates on the same loan, enter the average.'}
        onChange={(e) => setInterestRate(numberClearCommas(e.target.value))}
      />
      <EstimateInput
        label="Other monthly fees"
        placeholder="Enter fees"
        id={'monthyl-amount'}
        icon="$"
        value={otherMonthlyFees}
        tooltipText={'Enter any monthly on-going account fees and charges that you pay. If you have an annual fee, divide it by 12 to convert to monthly.'}
        onChange={(e) => setOtherMonthlyFees(numberClearCommas(e.target.value))}
      />
      <EstimateInput
        label="Remaining loan term"
        placeholder="Enter loan term"
        id={'loan-term'}
        icon="years"
        value={remainingLoanTerm}
        tooltipText={'Enter the remaining loan term in years as per your current loan contract.'}
        onChange={(e) => setRemainingLoanTerm(numberClearCommas(e.target.value))}
      />

      <button 
        className="btn w-100 btn-lg btn-green mr-sm-2 calculate-button" 
        id="apply-now-btn" 
        href='/onboarding_funnel/new'
        onClick={getCalculation}
        disabled={buttonDisabled}
      >
        Calculate
      </button>
      
      <div className="homepage-calculator-assumptions">
        <CalculatorAssumptions 
          assumptionBoxContents={<AssumptionsContents />} 
          text={<b className='calculator-assumption'>Calculator assumptions <InfoIcon /></b>}
        />
      </div>

    </div>
  );
}

export default EstimateRefinancingCalc
